import { FC, MouseEventHandler, PropsWithChildren } from 'react'
import styles from './Slider2023.module.scss'
import Slider, { Settings } from 'react-slick'
import { amClickedButton } from 'events/amplitude'
import { arrow_left, arrow_right, Icon } from 'components/Icon'
import cx from 'classnames'
import { Theme } from 'components/_utils/utilityTypes'

export interface Slider2023Props extends PropsWithChildren {
	theme: Theme
	afterChange?: (currentSlide: number) => void
	beforeChange?: (currentSlide: number, nextSlide: number) => void
	settings?: Settings
}

export const Slider2023: FC<Slider2023Props> = (props) => {
	return (
		<Slider
			dots
			autoplay
			autoplaySpeed={5000}
			infinite
			slidesToScroll={1}
			swipeToSlide
			slidesToShow={1}
			speed={400}
			afterChange={props.afterChange}
			beforeChange={props.beforeChange}
			prevArrow={<LeftArrow theme={props.theme} />}
			nextArrow={<RightArrow theme={props.theme} />}
			className={cx(styles.slider, { [styles.slider_light]: props.theme === 'light' })}
			{...props.settings}
		>
			{props.children}
		</Slider>
	)
}

const LeftArrow = (props: { onClick?: MouseEventHandler<HTMLButtonElement>; theme: Theme }) => (
	<button
		className={styles.arrow}
		aria-label="Previous slide"
		onClick={(e) => {
			amClickedButton('Previous Arrow', 'prev-arrow')
			props.onClick && props.onClick(e)
		}}
	>
		<Icon
			icon={arrow_left}
			color={props.theme === Theme.LIGHT ? '#000' : '#fff'}
		/>
	</button>
)
const RightArrow = (props: { onClick?: MouseEventHandler<HTMLButtonElement>; theme: Theme }) => (
	<button
		className={cx(styles.arrow, styles.arrow_right)}
		aria-label="Next slide"
		onClick={(e) => {
			amClickedButton('Next Arrow', 'next-arrow')
			props.onClick && props.onClick(e)
		}}
	>
		<Icon
			icon={arrow_right}
			color={props.theme === Theme.LIGHT ? '#000' : '#fff'}
		/>
	</button>
)
